"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
function FormDates(_a) {
    var dates = _a.dates, setDates = _a.setDates, clearDates = _a.clearDates, _b = _a.clearable, clearable = _b === void 0 ? false : _b;
    var _c = react_1.useState(dates), date = _c[0], setDate = _c[1];
    react_1.useEffect(function () {
        setDate(dates);
    }, [dates]);
    var errors = [];
    if (date.from > date.till) {
        errors.push({
            message: 'De periode kan niet eindigen voor de startdatum',
        });
    }
    return react_1.default.createElement("div", { className: 'storybook-analytics-form-dates' },
        react_1.default.createElement("div", { className: 'flex flex-col md:flex-row md:justify-center gap-4 items-end' },
            react_1.default.createElement("div", { className: 'w-full' },
                react_1.default.createElement(storybook_1.Forms.Label, null, "STARTDATUM"),
                react_1.default.createElement(storybook_1.Forms.Input, { type: 'date', value: date.from, onChange: function (from) { return setDate(__assign(__assign({}, date), { from: from })); } })),
            react_1.default.createElement("div", { className: 'w-full' },
                react_1.default.createElement(storybook_1.Forms.Label, null, "EINDDATUM"),
                react_1.default.createElement(storybook_1.Forms.Input, { type: 'date', value: date.till, onChange: function (till) { return setDate(__assign(__assign({}, date), { till: till })); } })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(storybook_1.Buttons.Button, { onClick: function () { return setDates(date); }, icon: 'search', type: 'light', className: 'w-full', outline: true }))),
        Boolean(errors.length) && react_1.default.createElement(storybook_1.Forms.Errors, { errors: errors }));
}
exports.default = FormDates;
